import Lottie from 'lottie-web'
import React, { useEffect } from 'react'

const RenderAnimation = ({
  animationJSON = null,
  animationName = '',
  animationDivId = '',
  preserveAspectRatio = 'none',
  loop = true
}: any) => {

  useEffect(() => {
      Lottie.loadAnimation({
        container: document.getElementById(animationDivId),
        animationData: animationJSON,
        loop: loop,
        renderer: 'svg',
        name: animationName,
        rendererSettings: {
          preserveAspectRatio: preserveAspectRatio,
        }
      })
  },[])

  return (
    <div/>
  )
}

export default RenderAnimation;